export default __webpack_public_path__ + "static/media/syllabus_icon.adb4cde6.svg";